const toReadableTimeFormat = (time: number, withDays?: boolean) => {
  const days = Math.floor(time / 86400);
  const hours = Math.floor(time / 3600);
  const hoursMinusDays = Math.floor((time - days * 86400) / 3600);
  const minutes = Math.floor((time - hours * 3600) / 60);
  const seconds = Math.floor(time - hours * 3600 - minutes * 60);

  if (withDays)
    return (
      String(days) +
      ':' +
      String(hoursMinusDays).padStart(2, '0') +
      ':' +
      String(minutes).padStart(2, '0') +
      ':' +
      String(seconds).padStart(2, '0')
    );
  return (
    String(hours) + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')
  );
};

export default toReadableTimeFormat;
